module.exports = __webpack_public_path__ + "static/media/omnimon.77993c59.jpg";